import { createSlice } from "@reduxjs/toolkit";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  sagaSlice,
} from "./sagaStore";
import FetchSubscriptionPlansService from "../services/fetchSubscriptionPlans";
import type {
  PlanStatusFilter,
  SubscriptionPlansResponse,
} from "../types/subscriptionPlans";

export interface SubscriptionPlansState {
  list: {
    loading: boolean;
    error: string | null;
    /** Full API envelope — unwrap via `result.data`. */
    data: SubscriptionPlansResponse | Record<string, unknown>;
  };
  statusFilter: PlanStatusFilter;
  isFilterApplied: boolean;
  currentPage: number;
}

const initialState: SubscriptionPlansState = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  statusFilter: "all",
  isFilterApplied: false,
  currentPage: 1,
};

// Not persisted: the filter and page are transient view state, and a stale
// filter surviving a reload is more confusing than useful.
const Slice: sagaSlice = createSlice({
  name: "subscriptionPlans",
  initialState,
  reducers: {
    ...createSagaReducer("fetchSubscriptionPlans", "list"),
    updateStatusFilter(state, action) {
      state.statusFilter = action.payload;
      // Any filter change invalidates the current page offset.
      state.currentPage = 1;
    },
    updateFilterApplied(state, action) {
      state.isFilterApplied = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
  },
});

const fetchSubscriptionPlansSaga = createAsyncSaga(
  "fetchSubscriptionPlans",
  Slice,
  FetchSubscriptionPlansService.fetchSubscriptionPlans,
  ["page", "limit", "status"]
);

addSaga(Slice.actions.fetchSubscriptionPlans.type, fetchSubscriptionPlansSaga);

export const {
  fetchSubscriptionPlans,
  updateStatusFilter,
  updateFilterApplied,
  setCurrentPage,
} = Slice.actions;

export default Slice.reducer;
